// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__3rUEY","title":"AfterImages45_title__1dL1n","images":"AfterImages45_images__pv4k7"};